/*
single-product.js
    home page support
 */

// handle right-to-left language setting
const rtl = $('body').hasClass('rtl');

// slick slideshows
const $mainSlider = $('.whatsnext-slider').slick({
    rtl,
    arrows: false,
    dots: true,
    mobileFirst: true,
    adaptiveHeight: true,
    responsive: [
        {
            breakpoint: 769,
            settings: 'unslick',
        },
    ],
});

// when switching tabs - add setPosition call to make sure
//   slide is resized properly
$('.js-ui-tab').on('click', () => {
    //  $menuSlider.slick('slickGoTo', $(this).data('slickIndex'));
    $mainSlider.slick('setPosition');
});

// handling for home page alert
$('.js-alert-close').on('click', () => {
    $('.home-page-alert').hide();
});

// add class to hero CTA on Canadian site only
if (window.location.hostname.includes('clorox.ca') || window.location.hostname.includes('canada.clorox.com')) {
    $('.hero__main-cta').addClass('button__solid-white');
}

//Active slider home page
$(".slider").slick({
 
    infinite: true,
    draggable: true,
    easing: 'linear',
    dots: true,
    dotsClass: 'slick-dots',
    autoplay: true,
    autoplaySpeed: 3000,
    cssEase: 'ease',
    arrows: false,
    speed: 300,
    swipeToSlide: true,
    touchMove: true,
    useCSS: true
   
  });
